<div class="flex-container flex-align-center pt-16px pb-16px" [style.gap]="'0.5rem'">
  <app-checkbox-only class="mr-8px" [checked]="selected$ | async" (valueChanged)="clicked($event)"> </app-checkbox-only>
  <div class="d-flex" [style.gap]="'0.5rem'">
    <div class="display-name mr-8px">
      {{ selection?.name }}
    </div>
  </div>
</div>
<hr *ngIf="!last" class="no-margin" />
